import { getUsersMeOrganisationsCurrentDimensionsSelector } from "./getUsersMeOrganisationsCurrentDimensionsSelector";
import { RootState } from "../../../store";
import { DimensionWithCosts } from "../../../../services/cloudchipr.api";

export const dimensionsDataSelector = (
  state: RootState,
): DimensionWithCosts[] | undefined => {
  return getUsersMeOrganisationsCurrentDimensionsSelector(state)?.data;
};
